<section
  #panel
  class="note-access-panel"
  role="region"
  tabindex="-1"
  aria-label="Note access"
  [attr.aria-busy]="view().pending"
  (keydown.escape)="closePanel($event)"
>
  @if (view().state === 'ready' && view().access) {
    <div class="note-access-owner">
      <div class="note-access-owner-details">
        <div class="note-access-owner-name">
          <span class="note-access-avatar note-access-person-avatar">
            @if (view().owner?.avatarUrl; as avatarUrl) {
              <img [src]="avatarUrl" alt="" />
            } @else {
              {{ ownerInitials() }}
            }
          </span>
          <span class="note-access-name" [title]="view().owner?.name ?? 'Former member'">
            {{ view().owner?.name ?? 'Former member' }}
          </span>
        </div>
        @if (view().owner?.email; as email) {
          <span class="note-access-email" [title]="email">{{ email }}</span>
        }
      </div>
      <span class="note-access-owner-badge">Owner</span>
    </div>
    <div class="note-access-divider"></div>
    <div class="note-access-level">
      <span class="note-access-heading">Access</span>
      <div class="note-access-field">
        <span class="note-access-team">
          <span class="note-access-avatar note-access-team-avatar">{{ teamInitials() }}</span>
          <span class="note-access-name" [title]="teamName()">{{ teamName() }}</span>
        </span>
        <app-button2
          #valueButton
          class="note-access-value"
          appearance="secondary-ghost"
          size="s"
          [disabled]="!canChange()"
          [ariaLabel]="'Team access: ' + accessLabel()"
          [ariaDescribedBy]="showReason() ? reasonId : null"
          [ariaExpanded]="optionsOpen()"
          [ariaControls]="optionsId"
          ariaHaspopup="menu"
          stchPopover
          stchPopoverTrigger="click"
          [stchPopoverTemplate]="options"
          stchPopoverPlacement="bottomLeft"
          [stchPopoverOffsetY]="2"
          [stchPopoverDisabled]="!canChange()"
          [stchPopoverNoBorder]="true"
          [stchPopoverCloseOnOutsideClick]="true"
          [stchPopoverShowUntil]="closeOptions"
          (stchPopoverVisibleChange)="optionsVisible($event)"
        >
          {{ accessLabel() }}
          @if (view().editable) {
            <app-icon name="sapphire-chevron-down" size="s" />
          }
        </app-button2>
      </div>
      @if (showReason()) {
        <p class="note-access-description note-access-reason" [id]="reasonId">{{ reason }}</p>
      }
      <p class="note-access-description">
        @if (view().access === 'editor') {
          Team members can edit, comment, and assign.
        } @else {
          Team members can view, comment, and be assigned. Only the note owner can assign team members.
        }
      </p>
    </div>
  } @else if (view().state === 'loading') {
    <p role="status">Loading note access…</p>
  } @else if (view().state === 'legacy') {
    <p>Access settings are unavailable for notes created before collaboration.</p>
  } @else {
    <p role="alert">Could not load note access.</p>
    <app-button2 appearance="secondary-text" size="s" (click)="retry.emit()">Retry</app-button2>
  }
  @if (view().error && view().state === 'ready') {
    <p class="note-access-error" role="alert">{{ view().error }}</p>
  }
</section>

<ng-template #options>
  <div
    [id]="optionsId"
    class="note-manage-access"
    role="menu"
    aria-label="Manage access"
    (keydown)="optionsKeydown($event)"
  >
    <span class="note-manage-heading">Manage access</span>
    <button
      type="button"
      role="menuitemradio"
      [attr.aria-checked]="view().access === 'read_only'"
      [class.note-access-selected]="view().access === 'read_only'"
      [disabled]="!canChange()"
      (click)="choose('read_only')"
    >
      <span class="note-access-option-title"
        >Read only
        @if (view().access === 'read_only') {
          <app-icon name="sapphire-check" size="s" />
        }
      </span>
      <span class="note-access-description">Team members can view, comment, and be assigned by you.</span>
    </button>
    <button
      type="button"
      role="menuitemradio"
      [attr.aria-checked]="view().access === 'editor'"
      [class.note-access-selected]="view().access === 'editor'"
      [disabled]="!canChange()"
      (click)="choose('editor')"
    >
      <span class="note-access-option-title"
        >Editor
        @if (view().access === 'editor') {
          <app-icon name="sapphire-check" size="s" />
        }
      </span>
      <span class="note-access-description">Your team can edit, comment, and assign.</span>
    </button>
  </div>
</ng-template>
